import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
  slots: {
    base: 'relative z-50 transition duration-300 ease-out data-[closed]:opacity-0',
    backDrop: 'fixed inset-0 bg-black/70',
    wrapper: 'fixed inset-0 flex w-screen items-center justify-center p-2 md:p-4',
    panel: 'bg-white rounded-[0.8rem] p-2 sm:p-4 md:p-6',
  }
});

export type PopupFormVariants = VariantProps<typeof styles>;